import { Call } from '@twilio/voice-sdk';

import type { TwilioDeviceOptions } from './types';

/**
 * Builds the Twilio Device options, optionally configuring custom ICE servers
 * for TCP-mode connectivity.
 */
export function makeTwilioDeviceOptions(
  iceServers: Array<RTCIceServer> | null,
): Partial<TwilioDeviceOptions> {
  const twilioOptions: Partial<TwilioDeviceOptions> = {
    closeProtection: true,
    codecPreferences: [Call.Codec.Opus],
    audioConstraints: {
      noiseSuppression: true,
      echoCancellation: true,
    },
  };

  // If iceServers looks like a decent candidate to contain configuration
  if (iceServers && iceServers.length > 0) {
    console.info('Configuring Twilio to run in TCP mode');
    twilioOptions.iceServers = iceServers;
  }

  return twilioOptions;
}
